import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { IconModule, MediaModule } from '@spartacus/storefront'
import { HighlightPipe } from '../../pipes/highlight.pipe'
import { CustomFooterNavigationModule } from './custom-footer-navigation/custom-footer-navigation.module'
import { CustomSearchBoxComponent } from './custom-search-box/custom-search-box.component'

@NgModule({
  imports: [CommonModule, RouterModule, MediaModule, IconModule, UrlModule, I18nModule, CustomFooterNavigationModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchBoxComponent: {
          component: CustomSearchBoxComponent
        }
      }
    })
  ],
  declarations: [CustomSearchBoxComponent, HighlightPipe],
  exports: [CustomSearchBoxComponent]
})
export class CustomSearchBoxModule {}
